import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Specialization extends Mappeable {

    idTypeSpecialityPk: number;
    txtTypeSpeciality: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        //this.mrkActive = this.mrkActive ??  "0" 
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            //mrkActive: this.mrkActive,
            txtTypeSpeciality: this.txtTypeSpeciality,
            mrkActive: this.mrkActive
        }
    }

}